function getDepartmentFromEmployeeId(departmentData, employeeId) {
  let found = null;
  departmentData.forEach((department) => {
    department.employee.forEach((emp) => {
      if (emp.employeeId == employeeId) {
        found = department.name;
      }
    });
  });

  return found;
}

function getFirstDateOfMonth(month, year) {
  let datum =
    year +
    "-" +
    String(month).padStart(2, "0") +
    "-" +
    String(1).padStart(2, "0");

  console.log("datum");
  console.log(String(month).padStart(2, "0"));
  console.log(datum);

  let date = new Date(datum);

  return date;
}

var lastday = function(y, m) {
  return new Date(y, m, 0).getDate();
};

function getLastDateOfMonth(month, year) {
  let datum = getFirstDateOfMonth(month, year);
  console.log("year is ");
  console.log(year);
  console.log("month is");
  console.log(month);
  let x = lastday(year, month);
  console.log("x is:");
  console.log(x);
  datum = addDays(datum, x - 1); //TODO: Here is a bug!

  return datum;
}

function getDateFromTicks(ticks) {
  if (ticks >= 0) {
    //get seconds from ticks
    var ts = ticks / 10000000;

    //conversion based on seconds
    var hh = Math.floor(ts / 3600);
    var mm = Math.floor((ts % 3600) / 60);
    var ss = (ts % 3600) % 60;

    //prepend '0' when needed
    hh = hh < 10 ? "0" + hh : hh;
    mm = mm < 10 ? "0" + mm : mm;
    ss = ss < 10 ? "0" + ss : ss;

    //use it
    var str = hh + ":" + mm + ":" + ss;
    // console.log(str);
    // if (str == '01:00:00')
    //   str = "";
    str = str.split(".")[0];
    return str;
  } else {
    //get seconds from ticks
    ts = -ticks / 10000000;

    //conversion based on seconds
    hh = Math.floor(ts / 3600);
    mm = Math.floor((ts % 3600) / 60);
    ss = (ts % 3600) % 60;

    //prepend '0' when needed
    hh = hh < 10 ? "0" + hh : hh;
    mm = mm < 10 ? "0" + mm : mm;
    ss = ss < 10 ? "0" + ss : ss;

    //use it
    str = hh + ":" + mm + ":" + ss;
    // console.log(str);
    // if (str == '01:00:00')
    //   str = "";
    str = str.split(".")[0];
    return "-" + str;
  }
}

function getSecondsFromTicks(ticks) {
  // get seconds from ticks
  var ts = ticks / 10000000;

  return ts;
}

function getShortTimeFromTicks(ticks) {
  if (ticks >= 0) {
    //get seconds from ticks
    var ts = ticks / 10000000;

    //conversion based on seconds
    var hh = Math.floor(ts / 3600);
    var mm = Math.floor((ts % 3600) / 60);
    // var ss = (ts % 3600) % 60;

    //prepend '0' when needed
    hh = hh < 10 ? "0" + hh : hh;
    mm = mm < 10 ? "0" + mm : mm;
    // ss = ss < 10 ? "0" + ss : ss;

    //use it
    var str = hh + ":" + mm;
    // console.log(str);
    // if (str == '01:00:00')
    //   str = "";
    return str;
  } else {
    //get seconds from ticks
    ts = -ticks / 10000000;

    //conversion based on seconds
    hh = Math.floor(ts / 3600);
    mm = Math.floor((ts % 3600) / 60);
    // var ss = (ts % 3600) % 60;

    //prepend '0' when needed
    hh = hh < 10 ? "0" + hh : hh;
    mm = mm < 10 ? "0" + mm : mm;
    // ss = ss < 10 ? "0" + ss : ss;

    //use it
    str = hh + ":" + mm;
    // console.log(str);
    // if (str == '01:00:00')
    //   str = "";
    return "-" + str;
  }
}

function getEventFromAccessLog(accessLog, checkpointNames) {
  let cp = checkpointNames.find((e) => {
    return e.checkpointId === accessLog.checkpointId;
  });
  // console.log("cp");
  // console.log(cp);

  // console.log("locationName");
  // console.log(locationName);

  // if (locationName === undefined) {
  //   locationName = "patka";
  // }

  // console.log("locationName");
  // console.log(locationName);
  if (cp === undefined) {
    cp = { name: "undefined!" };
  }

  let returnString = "";
  if (accessLog.accessType !== "remote") {
    if (accessLog.checkpointId !== null) {
      returnString = cp.name;
    } else {
      returnString =
        accessLog.choiceId !== null
          ? "🌳 odlazak sa unijetim razlogom"
          : accessLog.enteredAreaId === 1
          ? "🏢 ulazak u krug preduzeća"
          : accessLog.enteredAreaId == null ||
            /*(element.enteredAreaId === 2 && */ accessLog.choiceId !==
              null /*)*/
          ? "🌳 odlazak napolje"
          : accessLog.enteredAreaId === 2 && accessLog.choiceId == null
          ? "🍔 odlazak u kuhinju"
          : (accessLog.enteredAreaId === 3 || accessLog.enteredAreaId === 11) &&
            accessLog.choiceId == null
          ? "🚬 odlazak u prostoriju za pušenje"
          : "🏢 ulazak";
    }
  } else if (accessLog.accessType === "remote") {
    returnString =
      accessLog.enteredAreaId === 1 ? "🏁 udaljeni start" : "🛑 udaljeni stop";
  }
  return returnString;
}

function getDeviceFromAccessLog(accessLog) {
  let returnString =
    accessLog.sender == "mifare"
      ? "💳 mifare " + "#" + accessLog.checkpointId
      : accessLog.sender == "uhf"
      ? "🎛️ uhf" + "#" + accessLog.checkpointId
      : accessLog.sender == "cam"
      ? "🎥 cam" + "#" + accessLog.checkpointId
      : accessLog.sender == "remote"
      ? "📲 phone"
      : "🛰️ gps";

  return returnString;
}

function getAccessTypeFromAccessLog(accessLog, locationName) {
  let returnString =
    accessLog.accessType == "pješak"
      ? "🚶 " + getLeavingReasonStringFromId(accessLog.choiceId)
      : accessLog.accessType == "teretno"
      ? "🚚 " + accessLog.accessMetadata
      : accessLog.accessType == "putničko"
      ? "🚗 " + accessLog.accessMetadata
      : "📲 " + locationName + "..." + accessLog.accessMetadata.split("; ")[1];

  return returnString;
}

function getStartedYesterdayStayString(log) {
  if (log.didIstartedYesterday) {
    console.log("startovao juče!");
    return " 🌜";
  }
  return "";
}

function getStayedTillTomorrowString(log) {
  if (log.didIstayedTillTomorrow) {
    console.log("ostao do sjutra!");
    console.log(log);
    return " 🌜";
  }
  return "";
}

function getBusinessEventString(events) {
  let duration = 0;
  let count = 0;
  events.forEach((oe) => {
    if (
      oe.isLogicallyClosed &&
      (oe.leavingReasonId === null || oe.leavingReasonId === 901)
    ) {
      duration += oe.duration;
      count++;
    }
  });

  return "br:" + count + " vr:" + getDateFromTicks(duration);
}

function getRestEventString(events) {
  let duration = 0;
  let count = 0;
  events.forEach((oe) => {
    if (oe.isLogicallyClosed && oe.leavingReasonId === 904) {
      duration += oe.duration;
      count++;
    }
  });

  return "br:" + count + " vr:" + getDateFromTicks(duration);
}

function getPrivateEventString(events) {
  let duration = 0;
  let count = 0;

  events.forEach((oe) => {
    if (oe.isLogicallyClosed && oe.leavingReasonId === 902) {
      duration += oe.duration;
      count++;
    }
  });

  return "br:" + count + " vr:" + getDateFromTicks(duration);
}

function getPauseEventString(events) {
  let duration = 0;
  let count = 0;

  events.forEach((ie) => {
    duration += ie.duration;
    count++;
  });

  return "br:" + count + " vr:" + getDateFromTicks(duration);
}

function getPauseEventLength(events) {
  let duration = 0;

  events.forEach((ie) => {
    duration += ie.duration;
  });

  return duration;
}

function getLeavingReasonStringFromId(id) {
  switch (id) {
    case 901:
      return "💼 službeno";
    case 902:
      return "🔒 privatno";
    case 903:
      return "☕ pauza";
    case 904:
      return "🏠 odlazak sa posla";
    case null:
      return "";
    default:
      return "nepoznato";
  }
}

function isWorkingDayFromDate(date) {
  let shortDesc = date.toLocaleDateString("sr-latn-cs", {
    weekday: "short",
  });

  if (["ned"].includes(shortDesc)) return false;
  if (["sub"].includes(shortDesc)) return false;
  else return true;
}

function ifArrayContainsObject(array, object) {
  if (
    array.some(
      (e) =>
        e.accessTime == object.accessTime /* && e.sender == object.sender*/,
    )
  ) {
    /* vendors contains the element we're looking for */
    return true;
  }
}

function maskIfEquealsValue(value, mask) {
  if (value == mask) return "";
  else return value;
}

function getStatusCodeFromStatusId(statusId, statusIdOverride, statuses) {
  let myStatus = statuses.find((s) => {
    return s.statusId === statusId;
  });

  let myOverrideStatus = statuses.find((s) => {
    return s.statusId === statusIdOverride;
  });

  let overrideString = "";

  if (myOverrideStatus) {
    overrideString = myOverrideStatus.code;
  }

  if (myStatus) {
    return myStatus.code + overrideString;
  }
  return "";
}

function getMonthNameFromId(monthId) {
  switch (monthId) {
    case 1:
      return "Januar";
    case 2:
      return "Februar";
    case 3:
      return "Mart";
    case 4:
      return "April";
    case 5:
      return "Maj";
    case 6:
      return "Jun";
    case 7:
      return "Jul";
    case 8:
      return "Avgust";
    case 9:
      return "Septembar";
    case 10:
      return "Oktobar";
    case 11:
      return "Novembar";
    case 12:
      return "Decembar";
  }
}

function getReport01TitlePropertyFromStatusId(statusId) {
  switch (statusId) {
    case 2:
      return "Godišnji odmor";
    case 3:
      return "Bolovanje";
    case 5:
      return "Slobodan dan";
    case 7:
      return "Slobodan dan";
    case 9:
      return "Slobodan dan";
    case 10:
      return "Trudničko i porodiljsko bolovanje";
    // case 12:
    //   return "Trudničko i porodiljsko bolovanje";
  }
}

function getReport01recursivePropertyFromStatusId(statusId) {
  switch (statusId) {
    case 2:
      return "R";
    case 3:
      return "R";
    case 5:
      return "R";
    case 7:
      return "R";
    case 9:
      return "R";
    case 10:
      return "R";
    // case 12:
    //   return "Trudničko i porodiljsko bolovanje";
    default:
      return "N";
  }
}

function getDailyLogsFromDepartmentId(dailyLogs, departmentId) {
  let returnLogs = [];
  dailyLogs.forEach((dlog) => {
    if (dlog.departmentId == departmentId) returnLogs.push(dlog);
  });
  return returnLogs;
}

function removeItemOnce(arr, employeeId) {
  // console.log("remove item once");
  // console.log(arr);
  // console.log(employeeId);
  var index = arr.indexOf(arr.find((e) => e.id === employeeId));
  // console.log(index);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}

function getDaysArray(start, end) {
  for (
    var arr = [], dt = new Date(start);
    dt < end;
    dt.setDate(dt.getDate() + 1)
  ) {
    arr.push(new Date(dt));
  }
  return arr;
}

function getFromDateOnlyDatePart(date) {
  return new Date(date.toDateString());
}

function doesArrayContainsObject(obj, list) {
  var i;
  for (i = 0; i < list.length; i++) {
    if (list[i] === obj.department) {
      return true;
    }
  }

  return false;
}

function shouldEmployeeBeAdded(emp, selectedMonth, selectedYear) {
  if (
    (emp.status &&
      (emp.startDate != null
        ? new Date(emp.startDate) <
          getLastDateOfMonth(selectedMonth, selectedYear)
        : true) &&
      new Date(emp.endDate)) ||
    (new Date(emp.endDate) >= new Date(selectedYear, selectedMonth - 1, 1) &&
      new Date(emp.startDate) < getLastDateOfMonth(selectedMonth, selectedYear))
  ) {
    return true;
  } else {
    return false;
  }
}

function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function getLateHoursFromTicks(element) {
  let result = maskIfEquealsValue(
    getDateFromTicks(element.lateWorkhours),
    "00:00:00",
  );
  if (element.isLate) {
    if (element.isLateJustified) {
      result += " KO";
    } else {
      result += " KN";
    }
  }
  return result;
}

// function getActiveEmployeesFromDepartmentData(departmentData) {
//   let activeEmployees = [];

//   departmentData.forEach((department) => {
//     department.employee.forEach((employee) => {
//       if (employee.status) {
//         activeEmployees.push({
//           id: employee.employeeId,
//           name: employee.firstName + " " + employee.lastName,
//         });
//       }
//     });
//   });

//   // add null option
//   // activeEmployees.push({
//   //   id: null,
//   //   name: "NESELEKTOVANO",
//   // });

//   return activeEmployees;
// }

export {
  getDepartmentFromEmployeeId,
  getDateFromTicks,
  getShortTimeFromTicks,
  getSecondsFromTicks,
  getEventFromAccessLog,
  getAccessTypeFromAccessLog,
  getDeviceFromAccessLog,
  ifArrayContainsObject,
  maskIfEquealsValue,
  isWorkingDayFromDate,
  getLeavingReasonStringFromId,
  getStartedYesterdayStayString,
  getStayedTillTomorrowString,
  getStatusCodeFromStatusId,
  getMonthNameFromId,
  getDailyLogsFromDepartmentId,
  removeItemOnce,
  getReport01TitlePropertyFromStatusId,
  getDaysArray,
  getFromDateOnlyDatePart,
  getBusinessEventString,
  getRestEventString,
  getPrivateEventString,
  doesArrayContainsObject,
  getReport01recursivePropertyFromStatusId,
  addDays,
  getFirstDateOfMonth,
  getLastDateOfMonth,
  shouldEmployeeBeAdded,
  getLateHoursFromTicks,
  getPauseEventString,
  getPauseEventLength,
  // getActiveEmployeesFromDepartmentData,
}; // a list of exported variables
